import { post,get,postNowap,postAES } from "@/api/request"

export const indexBanner = params => post("/v1/home/first/gather", params)//首页banner
export const indexBannerV2 = params => post("/v2/home/first/gather", params)//首页banner
export const indexGather = params => post("/v2/home/first/gather/top", params)//首页-头部-导航
export const indexFocus = params => post("/v2/special/focus", params)//关注

export const indexNews = params => post("/v1/home/news/lists", params)//拍卖快递（新闻）
export const indexRank = params => post("/v2/home/rank/top", params)//排行榜
export const getAmma = params => post("https://amma-api.artron.net/amma/index", params)//行情
export const indexMeeting = params => post("/v1/home/special/session", params)//拍卖会
export const indexAdv = params => post("/v1/home/advert", params)//首页广告
export const indexHot = params => post("/v1/home/class/auctionlist", params)//首页广告
export const indexHotV2 = params => postAES("/v3/home/class/auctionlist", params)//首页广告
export const indexFocusListV2 = params => post("/v2/focus/index", params)//关注首页
export const recommendSpecial = params => post("/v2/recommend/special", params)//为你推荐列表页
export const getAdvList = params => post("/v1/session/advert ", params)//首页广告
export const getSingleList = params => post("/v1/home/single/recommend ", params)//app首屏推荐图录

export const getHomeTabs = () => post('/v2/home/first/gather/top')
export const getActivitytip = () => post('/v2/activity/tip/ad')
export const getActivityClear = params => post('/v2/activity/tip/ad/clear', params)

export const tokenGet = params => get("https://artexpress.artron.net/bk/token/get ", params)//获取跨域token
export const bidAuctionInfo = params => post("https://auction-bid.artron.net/v2/auction/info", params)//竞价阶梯
export const subscribeSuccess = params => post("https://buy-api.artron.net/api/subscribe/success", params)//行情
export const activityBuyinfo = params => post("https://tulu-app.artron.net/member/activity/buyinfo", params)//会员活动购买
export const createOrderNew = params => postNowap("https://tulu.artron.net/wap/Buy/createOrderNew", params)//会员活动购买